import { render, staticRenderFns } from "./SvgElement.vue?vue&type=template&id=593c910d&scoped=true&"
import script from "./SvgElement.vue?vue&type=script&lang=js&"
export * from "./SvgElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593c910d",
  null
  
)

export default component.exports